import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

function defaultIconForVariant(variant: string | null | undefined) {
  if (variant === 'success') {
    return <CheckCircle2 className="size-6 shrink-0 text-white" strokeWidth={1.5} aria-hidden />;
  }
  if (variant === 'error' || variant === 'destructive') {
    return <AlertCircle className="size-6 shrink-0 text-white" strokeWidth={1.5} aria-hidden />;
  }
  return null;
}

/**
 * Circus Daily toaster — Figma bottom toasts with icon / message / action|close.
 */
export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, icon, variant, ...props }) {
        const leadingIcon = icon ?? defaultIconForVariant(variant);

        return (
          <Toast key={id} variant={variant} {...props}>
            {leadingIcon}
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action ?? <ToastClose />}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
